module.exports = __webpack_public_path__ + "static/media/easyrent.a01a9acc.png";